import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api';
import { useLang } from '../context/LangContext';
import InvoiceForm from '../components/InvoiceForm';

export default function InvoiceDetailPage() {
  const { id } = useParams();
  const isNew = !id;
  const { t } = useLang();
  const navigate = useNavigate();
  const [conns, setConns]     = useState([]);
  const [invoice, setInvoice] = useState(isNew ? {} : null);
  const [loading, setLoading] = useState(!isNew);

  useEffect(() => {
    api.get('/api/connections').then(r => setConns(r.data));
    if (!isNew) {
      api.get(`/api/invoices/${id}`)
        .then(r => setInvoice(r.data))
        .finally(() => setLoading(false));
    }
  }, [id, isNew]);

  async function handleDelete() {
    if (!window.confirm(t('confirm_delete'))) return;
    await api.delete(`/api/invoices/${id}`);
    navigate('/invoices');
  }

  const ready = conns.length > 0 && invoice !== null && !loading;

  return (
    <>
      <div className="page-header">
        <h2>{isNew ? t('inv_new') : t('inv_number') + ' ' + (invoice?.invoice_number || '')}</h2>
        <div className="d-flex gap-2">
          {!isNew && invoice?.pdf_filename && (
            <a className="btn btn-outline-secondary btn-sm"
               href={`/uploads/invoices/${invoice.pdf_filename}`} target="_blank" rel="noreferrer">
              <i className="bi bi-file-earmark-pdf me-1" />PDF
            </a>
          )}
          {!isNew && (
            <button className="btn btn-outline-danger btn-sm" onClick={handleDelete}>
              <i className="bi bi-trash me-1" />{t('delete')}
            </button>
          )}
          <button className="btn btn-link btn-sm text-muted" onClick={() => navigate('/invoices')}>
            <i className="bi bi-arrow-left me-1" />{t('back')}
          </button>
        </div>
      </div>

      <div className="page-body" style={{ maxWidth: 900 }}>
        {conns.length === 0 ? (
          <div className="alert alert-warning">
            Maak eerst een aansluiting aan onder <strong>{t('nav_connections')}</strong>.
          </div>
        ) : !ready ? (
          <div className="text-center text-muted py-4">
            <div className="spinner-border spinner-border-sm me-2" />{t('loading')}
          </div>
        ) : (
          <InvoiceForm
            connections={conns}
            initial={invoice}
            invoiceId={isNew ? null : id}
          />
        )}
      </div>
    </>
  );
}
